<template lang="pug">
  .card-element
    form(@submit.prevent="submit")#payment-form
      .form-row
        .field.is-horizontal
          label.label.name {{ inputName }}
          .field-body
            input.input(
              type="number"
              :max="amountMax"
              :min="amountMin"
              v-model="amount"
              :disabled="disabled"
              :class="{'is-danger': $v.amount.$error || error}"
              @input="inputData")
        label(for="card-element") {{label}}
        #card-element
          <!-- A Stripe Element will be inserted here. -->
        #card-errors(role="alert") {{displayError}}
      button(v-if="button") {{button}}
      slot
</template>
<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { minValue, maxValue, required } from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

export default {
  name: 'CardElement',
  data () {
    return {
      amount: '',
      stripe: {},
      card: {},
      displayError: '',
      complete: false,
      token: ''
    }
  },
  props: {
    styleOptions: {
      default: () => {
        return {
          base: {
            color: '#32325d',
            lineHeight: '18px',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      }
    },
    label: {
      default: 'Credit or debit card'
    },
    button: {
      default: ''
    },
    apiKey: {
      default: ''
    },
    inputName: {
      default: 'Amount'
    },
    amountMin: {
      default: 0
    },
    amountMax: {
      default: 100
    },
    autoSubmit: {
      default: true
    },
    data: {
      default: () => {
        return {}
      }
    },
    disabled: {
      default: false
    },
    error: {
      default: ''
    }
  },
  validations () {
    return {
      amount: {
        minValue: minValue(this.amountMin),
        maxValue: maxValue(this.amountMax),
        required
      }
    }
  },
  methods: {
    init () {
      this.stripe = window.Stripe(this.apiKey)
      let elements = this.stripe.elements()
      this.card = elements.create('card', {style: this.styleOptions})
      this.card.mount('#card-element')
      this.card.addEventListener('change', (event) => {
        if (event.error) {
          this.displayError = event.error.message
        } else {
          this.displayError = ''
        }
        this.complete = event.complete
        if (event.complete && !event.error) {
          if (this.autoSubmit && this.amountValid) this.submit()
        }
      })
    },
    submit () {
      this.token = ''
      this.stripe.createToken(this.card).then((result) => {
        if (result.error) {
          // Inform the user if there was an error.
          this.displayError = result.error.message
        } else {
          // Send the token
          this.token = result.token.id
          this.$emit('token', result.token)
          if (this.isValid) this.$emit('result', {amount: this.amount, token: result.token.id})
        }
      })
    },
    inputData () {
      this.$v.amount.$touch()
      if (this.amountValid) this.$emit('updated', {amount: parseFloat(this.amount).toFixed(2), token: this.token})
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    amountValid: function () {
      return !this.$v.$invalid
    },
    isValid: function () {
      this.$v.amount.$touch()
      return this.amountValid && this.complete && Boolean(this.token)
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (val) {
        this.amount = parseFloat(val.amount)
      }
    },
    error: function (val) {
      this.displayError = val
    },
    isValid: function (val) {
      this.$emit('isValid', val)
    },
    complete: function (val) {
      this.$emit('complete', val)
    }
  },
  created () {
    this.$emit('created')
    this.$emit('isValid', false)
  }
}
</script>
<style lang="scss">
  .card-element {
    .field {
      &.is-horizontal {
        align-items: center;
        .label{
          margin: 0 10px 0 0;
        }
        .field-body {
          input {
            height: 35px;
            border: 1px solid #dbdbdb;
            &.is-danger {
              border: 1px solid #c60733;
            }
          }
        }
        p.error {
          color: #c60733;
          font-size: small;
        }
      }
    }
  }
  .credit-card{
    background-color: #f5f5f5;
    padding: 1rem;
  }
  .card-footer{
    button{
      height: 55px;
    }
  }
  .StripeElement {
    background-color: white;
    height: 40px;
    padding: 10px 12px;
    margin-top: 1rem;
    border-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/billing/invoice/components/card-element/index.vue